'use strict';

angular.module('randomization').factory('RecordRandomizationService', [
    '$window',
    'RecordsManagerService',
    'CrdConfigurationService',
    '$q',
    function(
        $window,
        RecordsManagerService,
        CrdConfigurationService,
        $q
    ) {
        var _ = $window._;

        var randomization = {};

        /**
         * Determina si el registro está aleatorizado
         *
         * @return {boolean} TRUE si el registro está aleatorizado
         */
        function isRandomized() {
            return !!randomization.createdAt;
        }

        return {
            /**
             * Carga la información de aleatorización desde el servicio de Data del registro
             *
             * @param {object} data Datos de aleatorización
             */
            load: function(data) {
                _.merge(randomization, data || {});
            },

            /**
             * Limpia los datos de aleatorización
             */
            reset: function() {
                _.each(randomization, function(value, key) {
                    _.unset(randomization, key);
                });
            },

            isRandomized: isRandomized,

            /**
             * Obtiene los datos de aleatorización del registro
             *
             * @return {object} Datos de aleatorización
             */
            get: function() {
                return randomization;
            },

            /**
             * Obtiene la configuración de brazos de aleatorización
             *
             * @return {object[]} Configuración de brazos
             *
             * @todo ¿Limpiar estos datos sensibles?
             */
            getBranches: function() {
                return CrdConfigurationService.getRandomization().getArms();
            },

            getRevelations: function() {
                if (!isRandomized() || !_.has(randomization, 'recordData.uid')) {
                    return $q.resolve([]);
                }

                return RecordsManagerService.getRevelations({
                    filters: 'randomizationId eq ' + randomization.id,
                    order: 'createdAt desc',
                }).then(function(response) {
                    return response.data;
                });
            },

            hasCohorts: function() {
                var configuration = CrdConfigurationService.getRandomization();

                return !_.isEmpty(configuration.getCohorts());
            },
        };
    }]);
